import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "@vds/buttons";
import { Modal } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { deleteMediaEndPoint } from "../../configuration";
import { deleteMedia } from "../../model/mediaService";
import { Notification } from "@vds/notifications";

const DeleteSiteConfirmationModal = ({
  title,
  showModal = false,
  setShowModal,
  onSubmit,
}) => {
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleBack = () => {
    handleCloseModal();
  };

  const renderCancelContent = () => {
    return (
      <>
        <Body size="medium">
          <Notification
            type="warning"
            hideCloseButton={true}
            title="Warning"
            subtitle="If deleted, users, cameras, and companions will no longer be associated with this site.  All app configurations for the cameras will also be lost. No events or alerts will be able to be generated for this site and all floor plans will be deleted."
          />
        </Body>
        <div
          style={{
            marginTop: "5%",
            marginBottom: "5%",
            justifyContent: "flex-start",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Title size="large" bold>
            Delete site
          </Title>
        </div>
        <div
          style={{
            marginBottom: "5%",
            justifyContent: "flex-start",
            display: "flex",
          }}
        >
          <Body size="large">Are you sure you'd like to delete this site?</Body>
        </div>

        <div
          style={{
            marginBottom: "5%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            size="medium"
            width="45%"
            disabled={false}
            use="primary"
            data-testid="deleteSitenModal_yesDeleteButton"
            onClick={onSubmit}
          >
            Yes, delete
          </Button>
          <Button
            size="medium"
            width="45%"
            disabled={false}
            use="secondary"
            data-testid="deleteSiteModal_noCancelButton"
            onClick={handleBack}
          >
            No, Cancel
          </Button>
        </div>
      </>
    );
  };

  return (
    <Modal
      opened={showModal}
      onOpenedChange={(opened) => {
        if (!opened) {
          handleCloseModal();
        }
      }}
      ariaLabel={title}
      disableOutsideClick={true}
    >
      {renderCancelContent()}
    </Modal>
  );
};

export default DeleteSiteConfirmationModal;
